import authHeader from "./auth.header";
import constants from "./constants.js";

const HOST_URL = constants.API_URL;

async function getJson(path) {
  const response = await fetch(`${HOST_URL}${path}`, {
    method: "GET",
    headers: { Accept: "application/json", ...authHeader() },
  });
  if (!response.ok) {
    const error = new Error(`Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export const getViewsCount = (entityType, entityId, period) =>
  getJson(`/views/${entityType}/${entityId}/count${period ? `/${period}` : ""}`);

export async function recordView(entityType, entityId) {
  const response = await fetch(`${HOST_URL}/views/${entityType}/${entityId}`, {
    method: "POST",
    headers: { Accept: "application/json", ...authHeader() },
  });
  return response.ok;
}

export const getFriendsCount = (userId) => getJson(`/users/${userId}/friends/count`);

export const getLatestFriendRequest = (userId) => getJson(`/users/${userId}/friends/requests/latest`);

export const getLastProfileViewer = (userId) => getJson(`/users/${userId}/profile-views/last`);

export const getLatestFriendReview = (userId) => getJson(`/users/${userId}/friends/latest-review`);

export const getLatestFriendPublishedArticle = (userId) => getJson(`/users/${userId}/friends/latest-article`);

export const getLatestIgoFavorite = (userId) => getJson(`/users/${userId}/favorites/igo/latest`);

export const getMyShares = (userId, limit = 20) => getJson(`/users/${userId}/shares?limit=${limit}`);

export const getViewsSummary = (userId) => getJson(`/users/${userId}/views/summary`);

export const getLatestAcceptedFriend = (userId) => getJson(`/users/${userId}/friends/accepted/latest`);

export const getProfileViewsSettings = (userId) => getJson(`/users/${userId}/profile-views/settings`);

export async function setProfileViewsAnonymous(userId, anonymous) {
  const response = await fetch(`${HOST_URL}/users/${userId}/profile-views/settings`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Accept: "application/json", ...authHeader() },
    body: JSON.stringify({ anonymous }),
  });
  if (!response.ok) {
    const error = new Error(`Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}
